import { render, staticRenderFns } from "./ProfileIndex.vue?vue&type=template&id=e4cd2824&"
import script from "./ProfileIndex.vue?vue&type=script&lang=js&"
export * from "./ProfileIndex.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports